<template>
  <div class="index-page container">
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Файл</h3>
      <a :href="$form.get('file')" target="_blank">Скачать</a>
      
      <n-form @submit="saveImage">
        <n-items>
          <n-upload title="Загрузить новый файл" :value.sync="newImage" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-input title="Заголовок" v-bind="$form.input('title')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление файла</h3>
      Осторожно! Удаление действие необратимо!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteModel">Удалить файл</n-button>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    newImage: null,
  }),
  computed: {
    modelId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    loadModel() {
      this.$var('load', true)
      $api.app.documents.get(this.modelId).then((response) => {
        const result = response.data.content
        this.$form.init(result)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const data = {
        title: this.$form.get('title'),
        content: this.$form.get('content'),
      }
      $api.app.documents.edit(this.modelId, data).then((result) => {
        this.loadModel()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    saveImage() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newImage, }).then((file) => {
        $api.app.documents.edit(this.modelId, { file: file.data.content.id, }).then((result) => {
          this.newImage = null
          this.$form.set('file', result.data.content.file)
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
    deleteModel() {
      this.$var('loadDelete', true)
      $api.app.documents.delete(this.modelId).then((response) => {
        this.$router.push({ name: 'documents.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
    
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .avatar {
      border: 2px solid red;
    }
  }
</style>
